import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnalyzeScorePayload, ScoreAnalysisData } from '@edtech-ui/core/models/resume-builder/resume-score-analyze';
import { ResumeService } from '@edtech-ui/core/services/resume-service/resume.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription, tap } from 'rxjs';

@Component({
	selector: 'app-resumer-check-score',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './resumer-check-score.component.html',
	styleUrl: './resumer-check-score.component.scss'
})
export class ResumerCheckScoreComponent implements OnDestroy {

	analyzing = true;
	subscription = new Subscription();
	analyzeData: ScoreAnalysisData | null = null;
	@Input() resumeId: string = '';
	@Output() close = new EventEmitter<void>();

	constructor(
		private resumeService: ResumeService,
		private toastr: ToastrService,
		private route: ActivatedRoute
	) { }

	postAnalyzeScore() {
		  if (!this.resumeId) return;
		  this.analyzing = true;

		this.subscription.add(
			this.resumeService.postAnalysisStudentScore(this.resumeId).pipe(
				tap(response => {
					this.analyzing = false;
					if (response.Success) {
						this.analyzeData = response.Data;
					}
				})
			).subscribe()
		);
	}



	closePopup() {
		this.close.emit();
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}


}